import { Pipe, PipeTransform } from '@angular/core';
 
@Pipe({ name: 'formatter' })
export class FormatterPipe implements PipeTransform {
  transform(val: any, formatterFunc?: (value: any) => string): string {
    return formatterFunc ? formatterFunc(val) : val;
  }
}
